import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'shouldManageWidth' && prop !== 'noPaperPadding' && prop !== 'width',
})<{ shouldManageWidth: boolean; noPaperPadding: boolean; width: string }>(
  ({ theme, shouldManageWidth, noPaperPadding, width }) => ({
    '& .MuiPaper-root': {
      width: width || '608px',
      maxWidth: '100%',
      margin: '8px',
      padding: noPaperPadding ? '' : '16px 0',
      borderRadius: 12,
      [theme.breakpoints.down('sm')]: {
        padding: noPaperPadding ? '' : '16px 0',
        maxWidth: shouldManageWidth ? 'calc(100% - 32px) !important' : undefined,
      },
    },
  })
);

export const StyledDialogContent = styled(DialogContent, {
  shouldForwardProp: (prop) => prop !== 'noScroll',
})<{ noScroll: boolean }>(({ theme, noScroll }) => ({
  overflow: noScroll ? 'visible' : 'auto',
  paddingLeft: 32,
  paddingRight: 32,
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 24,
    paddingRight: 24,
  },
}));
